import React from "react";
import { CarBookingWizard } from "../CarBookingWizard";
import { BarbershopBookingWizard } from "../BarbershopBookingWizard";
import {
  Service,
  TimeSlot,
  BookingData,
  Company,
  Professional,
} from "../../../types";

interface BookingWizardProps {
  company: Company | null;
  selectedDate: string;
  selectedService: Service | null;
  selectedSubServices?: number[];
  selectedProfessional: Professional | null;
  selectedTimeSlot: TimeSlot | null;
  timeSlots: TimeSlot[];
  professionals: Professional[];
  loading: boolean;
  professionalsLoading: boolean;
  error: string | null;
  phoneNumber: string;
  onDateChange: (date: string) => void;
  onServiceChange: (service: Service) => void;
  onSubServicesChange?: (subServiceIds: number[]) => void;
  onProfessionalChange: (professional: Professional) => void;
  onTimeSlotSelect: (timeSlot: TimeSlot) => void;
  bookAppointment: (bookingData: BookingData) => Promise<void>;
}

export const BookingWizard: React.FC<BookingWizardProps> = (props) => {
  const { company } = props;

  if (company?.category === "car") {
    return <CarBookingWizard {...props} />;
  } else if (company?.category === "barbershop") {
    return <BarbershopBookingWizard {...props} />;
  }
};

export default BookingWizard;
